import  {decodeJWT}                     from '../../lib/iprs-react-library/src/index.js';

/* Normalise a role claim to a list of individual role names, whether it comes
 * through as an array (multiple roles) or a string. A string claim may be a
 * single role, or several roles joined with commas (seen in practice), so it
 * has to be split before comparing - comparing the whole string against one
 * role name would wrongly fail for 'Diamond System Admin,Diary User,Diary Rota'. */
const roleList = claim => {
    if (Array.isArray(claim)) return claim
    if ('string' === typeof claim) return claim.split(',').map(r => r.trim())
    return []
}

/* Exact match against a single role name in the list. Using .includes()
 * directly on the raw claim string would do a substring match, so e.g. a
 * claim of 'Diary Rota Delete' would wrongly satisfy a check for 'Diary Rota'. */
const claimHasRole = (claim, role) => roleList(claim).includes(role)

/**
 * Whether the logged in user has the given role, e.g. 'Diary Rota' or
 * 'Diary Manager'. The permission is marked by having that role in the
 * logged in web token.
 * @param {object} api
 * @param {string} role exact role name
 * @returns {boolean}
 */
const userLoggedInHasRole = (api, role) => {

    const jwt = api.getToken() ? decodeJWT(api.getToken()) : null;

    // roles is the standard claim but we have used role in the past
    const result = claimHasRole(jwt?.roles, role) || claimHasRole(jwt?.role, role);

    return result
}

export default userLoggedInHasRole;
